  // 获取 URL 参数
  function get_param() {
    let app_url = window.location.href;
    let paramObj = {};
    if (app_url.indexOf('?')!== -1) {
      let params = app_url.split('?')[1];
      let paramArray = params.split('&');
      for (let i = 0; i < paramArray.length; i++) {
        let param = paramArray[i].split('=');
        let key = decodeURIComponent(param[0]);
        let value = decodeURIComponent(param[1]);
        paramObj[key] = value;
      }
    }
    return paramObj;
  }

  // 隐藏指定类名的元素
  function hideElements(list) {
    try {
      list.forEach(item => {
        if(item.type == 'class'){
          const elements = document.querySelectorAll(item.name);
          elements.forEach(ele => {
            ele.style.display = 'none';
          });
        }else if(item.type == 'id'){
          const elements = document.getElementById(item.name);
          elements.style.display = 'none';
        }
      });
    } catch (error) {
      console.error('隐藏元素时出现错误:', error);
    }
  }

  // h5的5.0及以下隐藏产品购买页面的客服按钮，顶、底部导航栏等
  function hiden_header() {
    let paramObj = get_param();
    try {
      const isApp = localStorage.getItem('equipment_type') === 'app' || paramObj['equipment_type'] === 'app';
      if (isApp) {
        if (paramObj['equipment_type'] === 'app') {
          localStorage.setItem('equipment_type', 'app');
        }
        //要隐藏部分的类名
        hideElements([
          {type: 'class', name:".app--hiden"},
        ]);
      }
    } catch (error) {
      console.error('处理 hiden_header 时出现 localStorage 错误:', error);
    }
  }

  // 商城版本隐藏产品购买页面除了A+图部分以外的内容
  function hiden_beyond_A() {
    let paramObj = get_param();
    try {
      const platform = localStorage.getItem('platform');
      const isPlatformValid = platform === 'ios' || platform === 'android' || paramObj['platform'] === 'ios' || paramObj['platform'] === 'android';
        if (isPlatformValid) {
          if (paramObj['platform'] && !platform) {
            localStorage.setItem('platform', paramObj['platform']);
          }
          //要隐藏部分的类名
          hideElements([
            {type: 'class', name:".announcement-container"}, //顶部优惠横幅
            {type: 'class', name:".header"}, //顶部导航栏
            {type: 'class', name:".product-template"}, //产品信息
            {type: 'class', name:".app--hiden"},
            {type: 'class', name:".customer_service"}, //客服按钮
            {type: 'class', name:".floatingNavigationBox"}, //A+图类型导航
            {type: 'class', name:".section_FAQ_box"}, //产品FAQ
            {type: 'class', name:".product__tech"}, //产品规格
            {type: 'class', name:".horizontal_video_products"}, //产品视频
            {type: 'class', name:".explore_list_products"}, //产品相关博客
            {type: 'class', name:".shopify-section--custom-liquid"}, //产品评论
            {type: 'class', name:".breadcrumb_box"}, //面包屑
            {type: 'class', name:".footer__container"}, //底部导航栏
            {type: 'id', name:"shopify-section-fixed-message"}, //cookie同意提示
            {type: 'id', name:"merchantwidget-iframe-wrapper"}, //谷歌优质商店入口
          ]);
        }
    } catch (error) {
      console.error('处理 hiden_beyond_A 时出现 localStorage 错误:', error);
    }
  }

  hiden_header();
  hiden_beyond_A();